import { gql } from '@apollo/client';

export const CONSUMPTION_PERIODS = gql`
    query ConsumptionPeriods(
        $first: Int
        $after: String
        $member: ID
        $company: ID
        $status: String
        $year: Int
        $month: Int
    ) {
        consumptionPeriods(
            first: $first
            after: $after
            member: $member
            company: $company
            status: $status
            year: $year
            month: $month
        ) {
            edges {
                node {
                    id
                    year
                    month
                    periodStart
                    periodEnd
                    status
                    closedAt
                    invoicedAt
                    createdAt
                    updatedAt
                    entryCount
                    calculatedTotal
                    billingEntityName
                    billingEntityType
                    member {
                        id
                        firstName
                        lastName
                        memberId
                    }
                    company {
                        id
                        name
                        companyId
                    }
                    invoice {
                        id
                        invoiceId
                        status
                        amount
                        document {
                            url
                        }
                    }
                }
            }
            pageInfo {
                hasNextPage
                endCursor
            }
            totalCount
        }
    }
`;

export const CONSUMPTION_PERIOD = gql`
    query ConsumptionPeriod($id: ID!) {
        consumptionPeriod(id: $id) {
            id
            year
            month
            periodStart
            periodEnd
            status
            closedAt
            invoicedAt
            createdAt
            updatedAt
            entryCount
            calculatedTotal
            billingEntityName
            billingEntityType
            member {
                id
                firstName
                lastName
                memberId
                email
            }
            company {
                id
                name
                companyId
                email
            }
            invoice {
                id
                invoiceId
                status
                amount
                subtotal
                taxTotal
                dueDate
                document {
                    url
                }
                lines {
                    id
                    description
                    quantity
                    unitPrice
                    lineTotal
                    taxAmount
                    source
                    sourceReference
                }
            }
        }
    }
`;
